import React, {createContext, useState, useContext, useCallback, useEffect} from 'react'
import {getHomeInfo, getContactInfo, getCompanyInfo, getProductInfo, getCertList, getGrowthList, getPartnersList, getAboutUsInfo, getAboutUsH5Data} from '@util/services'

// 创建context对象
const CommonContext = createContext()

// 创建provider组件
export const CommonProvider = ({ children }) => {
    // 联系方式信息
    const [contactInfo, setContactInfo] = useState(null)
    // 首页内容
    const [homeInfo, setHomeInfo] = useState(null)
    // 公司信息
    const [companyInfo, setCompanyInfo] = useState(null)
    // 产品列表
    const [productInfo, setProductInfo] = useState(null)
    // 荣誉证书
    const [certList, setCertList] = useState([])
    // 发展历程
    const [growthList, setGrowthList] = useState([])
    // 合作伙伴
    const [partnersList, setPartnersList] = useState([])
    // 关于我们
    const [aboutUsInfo, setAboutUsInfo] = useState([])
    // 关于我们-H5
    const [aboutUsH5Data, setAboutUsH5Data] = useState([])

    // 获取联系方式信息
    const fetchContractInfoData = useCallback(async () => {
        const res = await getContactInfo()
        res?.items && setContactInfo(res.items)
    }, [])

    // 获取首页内容信息
    const fetchHomeInfoData = useCallback(async () => {
        const res = await getHomeInfo()
        res?.items && setHomeInfo(res.items)
    }, [])

    // 获取公司信息
    const fetchCompanyInfoData = useCallback(async () => {
        const res = await getCompanyInfo()
        res?.items && setCompanyInfo(res.items)
    }, [])

    // 获取产品列表信息
    const fetchProductInfoData = useCallback(async () => {
        const res = await getProductInfo()
        res?.items && setProductInfo(res.items)
    }, [])

    // 获取荣誉证书
    const fetchCertInfoData = useCallback(async () => {
        const res = await getCertList()
        res?.items && setCertList(res.items)
    }, [])

    // 获取发展历程
    const fetchGrowthList = useCallback(async () => {
        const res = await getGrowthList()
        res?.items && setGrowthList(res.items)
    }, [])

    // 获取合作伙伴
    const fetchPartnerList = useCallback(async () => {
        const res = await getPartnersList()
        res?.items && setPartnersList(res.items)
    }, [])

    // 获取关于我们
    const fetchAboutUsInfo = useCallback(async () => {
        const res = await getAboutUsInfo()
        if (res) {
            setAboutUsInfo(res)
        }
    }, [])

    // 获取关于我们-H5
    const fetchAboutUsH5Info = useCallback(async () => {
        const res = await getAboutUsH5Data()
        if (res) {
            setAboutUsH5Data(res)
        }
    }, [])

    useEffect(() => {
        fetchContractInfoData()
        fetchHomeInfoData()
        fetchCompanyInfoData()
        fetchProductInfoData()
        fetchCertInfoData()
        fetchGrowthList()
        fetchPartnerList()
        fetchAboutUsInfo()
        fetchAboutUsH5Info()
        // eslint-disable-next-line
    }, [])

    // 提供context值
    const value = {
        contactInfo,
        homeInfo,
        companyInfo,
        productInfo,
        certList,
        growthList,
        partnersList,
        aboutUsInfo,
        aboutUsH5Data,
    }

    return (
        <CommonContext.Provider value={value}>
            {children}
        </CommonContext.Provider>
    )
}

// 创建自定义hook 方便在组件中使用
const useCommon = () => {
    const context = useContext(CommonContext)
    return context
}

export default useCommon
